import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { DICT } from './dictionary';

const LangContext = createContext({ lang: 'es', setLang: () => {}, t: (s) => s });
const KEY = 'notary_lang';
const originals = new WeakMap();
export const getLang = () => localStorage.getItem(KEY) || 'es';

axios.interceptors.request.use((config) => {
  config.headers['X-App-Lang'] = getLang();
  return config;
});

const shown = new WeakMap();

const translateNode = (node, dict) => {
  if (shown.get(node) !== node.nodeValue) originals.set(node, node.nodeValue);
  const orig = originals.get(node) || '';
  const key = orig.trim();
  const tr = dict && key && dict[key];
  const next = tr ? orig.replace(key, tr) : orig;
  if (node.nodeValue !== next) node.nodeValue = next;
  shown.set(node, next);
};

const walk = (root, dict) => {
  const w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let n;
  while ((n = w.nextNode())) translateNode(n, dict);
  if (root.querySelectorAll) root.querySelectorAll('input[placeholder],textarea[placeholder]').forEach((el) => {
    const o = el.dataset.phOrig || el.placeholder;
    const tr = dict && dict[o];
    if (tr) { el.dataset.phOrig = o; el.placeholder = tr; } else if (!dict && el.dataset.phOrig) el.placeholder = el.dataset.phOrig;
  });
};

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(getLang());
  const setLang = (l) => { localStorage.setItem(KEY, l); setLangState(l); };

  useEffect(() => {
    document.documentElement.lang = lang;
    const dict = DICT[lang] || null;
    walk(document.body, dict);
    if (!dict) return undefined;
    const obs = new MutationObserver((muts) => {
      obs.disconnect();
      muts.forEach((m) => {
        if (m.type === 'characterData') translateNode(m.target, dict);
        m.addedNodes.forEach((a) => (a.nodeType === 3 ? translateNode(a, dict) : a.nodeType === 1 && walk(a, dict)));
      });
      obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    return () => obs.disconnect();
  }, [lang]);

  const t = (s) => (DICT[lang] && DICT[lang][s]) || s;
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
